import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export type ConfirmPayoutMethodCall = (
  userID: number,
  token: string,
) => Promise<{ data: {} }>;

export default (makeCall: MakeCall) => (userID: number, token: string) =>
  makeCall<null>('PUT', `${APIV2_URL}/user/${userID}/payout-methods/confirm`, {
    data: { token },
  });
